import { ReactNode } from "react";
import { IntlProvider, createIntl, createIntlCache } from "react-intl";
import { useStoreState } from "ezStore";
import moment from "moment";

import "moment/dist/locale/nl";
import "moment/dist/locale/en-gb";
import "moment/dist/locale/de";
import "moment/dist/locale/vi";

const placeholderLanguage = {
	"LOGIN_USER": "Username",
	"LOGIN_PASSWORD": "Password",
	"REMEMBER_ME": "Remember me",
	"FORGOT_PASSWORD": "Password recovery",
	"LOGIN_TITLE": "Login",
	"NO_ACCOUNT_YET": "I don't have an account yet. Register here",
	"UPDATE_MESSAGE_1": "Refreshing environment...",
	"UPDATE_MESSAGE_2": "Updating to new version...",
	"UPDATE_MESSAGE_3": "Restarting...",
};

const LocaleWrapper = ({ children }: {
	children: ReactNode
}) => {

	const session = useStoreState((store) => store.session);
	const currentLocale = session.locale.toLowerCase();

	if (session.user?.language) {
		moment.locale(session.user.language);
	} else {
		moment.locale("en-GB");
	}

	return (
		<IntlProvider locale={currentLocale} messages={(session.language?.values || placeholderLanguage) as Record<string, string>}>
			{children}
		</IntlProvider>
	);
};

const cache = createIntlCache();

export const intl = createIntl({
	locale: localStorage.getItem("bosLanguageLocale")?.toLowerCase() || "en",
	messages: localStorage.getItem("bosLanguageKeys") ? JSON.parse(localStorage.getItem("bosLanguageKeys") as string) as Record<string, string> : placeholderLanguage,
}, cache);

export default LocaleWrapper;
